import { render, staticRenderFns } from "./contactsButtons.vue?vue&type=template&id=bdfab962&scoped=true"
import script from "./contactsButtons.vue?vue&type=script&lang=js"
export * from "./contactsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfab962",
  null
  
)

export default component.exports